'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var NavItem = function NavItem(props) {
  var title = props.link.image ? null : props.link.title;
  var image = props.link.image ? _react2.default.createElement('img', {
    className: 'nav-item__image',
    src: props.link.image,
    alt: props.link.title
  }) : null;
  return _react2.default.createElement('li', {
    className: 'nav-item ' + props.className
  }, _react2.default.createElement('a', {
    className: 'nav-item__link',
    href: props.link.url,
    onClick: props.link.onClick
  }, title, image, props.children));
};
NavItem.defaultProps = {
  children: null,
  className: ''
};
NavItem.propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  link: _propTypes2.default.shape({
    image: _propTypes2.default.string,
    onClick: _propTypes2.default.func,
    title: _propTypes2.default.string,
    url: _propTypes2.default.string
  }).isRequired
};
exports.default = NavItem;